import { Sesjonsklient } from './Sesjonsklient';

export class Sekvensklient {
	constructor(sid) {
		this._sesjonsklient = new Sesjonsklient(sid);
		this._etterspurt = 0;
		this._mottatt = 0;
	}
	_erForSent(kall) {
		if (kall < this._mottatt) {
			return true;
		}
		this._mottatt = kall;
		return false;
	}
	fetch(adresse, valg) {
		var kall = ++this._etterspurt;
		return this._sesjonsklient
			.fetch(adresse, valg)
			.then((r) => {
				if (!this._erForSent(kall)) {
					return r;
				}
			})
			.catch((e) => {
				if (!this._erForSent(kall)) {
					throw e;
				}
			});
	}
	laster() {
		return this._etterspurt > this._mottatt;
	}
}
